import { render, staticRenderFns } from "./Snoozing.vue?vue&type=template&id=17fd6052&"
import script from "./Snoozing.vue?vue&type=script&lang=js&"
export * from "./Snoozing.vue?vue&type=script&lang=js&"
import style0 from "./Snoozing.vue?vue&type=style&index=0&id=17fd6052&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports